import { ComponentType, EventSource, InteractionType, MixpanelEvent } from '../MixPanelTypes';

export type NotificationEvents =
  | 'DOWNLOAD_FROM_NOTIFICATION'
  | 'CLICK_TASK_NOTIFICATIONS_ICON'
  | 'CLICK_VIEW_ALL_NOTIFICATIONS_BUTTON'
  | 'SELECT_TASK_NOTIFICATION'
  | 'CLICK_NOTIFICATION_BELL'
  | 'CLICK_MARK_ALL_READ';

export const notification: Record<NotificationEvents, MixpanelEvent> = {
  DOWNLOAD_FROM_NOTIFICATION: {
    eventDescription: 'Download Export From Notification',
    eventKey: 'download-export-from-notification',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.NOTIFICATION_ITEM
  },
  CLICK_TASK_NOTIFICATIONS_ICON: {
    eventDescription: 'User clicked task notifications icon',
    eventKey: 'click-task-notifications-icon',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.NOTIFICATION_ITEM
  },
  CLICK_VIEW_ALL_NOTIFICATIONS_BUTTON: {
    eventDescription: 'User clicked view all notifications button',
    eventKey: 'click-view-all-notifications-button',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.NOTIFICATION_ITEM
  },
  SELECT_TASK_NOTIFICATION: {
    eventDescription: 'User selected task notification',
    eventKey: 'select-task-notification',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.NOTIFICATION_ITEM
  },
  CLICK_NOTIFICATION_BELL: {
    eventDescription: 'User opens the notification panel',
    eventKey: 'click-notifications-bell',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.NOTIFICATION_BELL
  },
  CLICK_MARK_ALL_READ: {
    eventDescription: 'User clicks Mark All Read in notification',
    eventKey: 'click-notifications-mark-all-read',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.NOTIFICATION_MARK_ALL_READ_BUTTON
  }
} as const;
